/*
 * @Author: YuanYuan
 * @Date: 2023-08-24 17:26:57
 * @LastEditTime: 2025-11-24 14:40:03
 * @description: 初始化项目
 * 设置开发环境菜单
 * 判断cdnw加载不同主题css
 */
import { $CDNW } from '@/utils/cdnw'

const addThemeStyle = () => {
  const CDN_SOURCE_URL = process.env.VUE_APP_PUBLISH_URL
  const WS_UI_VERSION = process.env.VUE_APP_WS_UI_VERSION
  const htmlEle = document.querySelector('html')
  let stylePath = ''
  if ($CDNW) {
    stylePath = `${CDN_SOURCE_URL}/lib/wsui/${WS_UI_VERSION}/theme-chalk/theme-cdnw.css`
    htmlEle.classList.remove('wspn-theme-default')
    htmlEle.classList.add('wspn-theme-gray-purple')
  } else {
    stylePath = `${CDN_SOURCE_URL}/lib/wsui/${WS_UI_VERSION}/theme-chalk/index.css`
    htmlEle.classList.remove('wspn-theme-gray-purple')
    htmlEle.classList.add('wspn-theme-default')
  }
  const container = document.getElementsByTagName('head')[0]
  const styleLink = document.createElement('link')
  styleLink.rel = 'stylesheet'
  styleLink.type = 'text/css'
  styleLink.href = stylePath
  container.appendChild(styleLink)
}

export const initProject = () => {
  addThemeStyle()
}
